import ImmutableRenderComponent from './immutable-render-component';

import React from 'react';
import Router from 'react-router';
const Link = Router.Link;

/**
 * QuestionEntryBox component: Lets the user enter custom question.
 */
export default class QuestionEntryBox extends ImmutableRenderComponent {
   constructor(props) {
     super(props);
     // question is stored in the state so that it can be
     // updated when the 'Ask Aristo' button is clicked.
     this.state = { question: this.props.question };
   }

  static get propTypes() {
    return {
      question: React.PropTypes.string,
    };
  }

  componentDidMount() {
    if (this.props.question){
      this.refs.questionInput.getDOMNode().focus();
    }
  }

  componentWillReceiveProps(props) {
    this.setState({ question: props.question });
    // If a new question was received (triggered by a user's selection of a featured
    // question), shift focus to the input field with the question.
    if (props.question !== undefined) {
      this.refs.questionInput.getDOMNode().focus();
    }
  }

  render() {
   const askQuestion = this.state.question ?
     <Link to="ask" query={{ q:this.state.question.replace(/\n/g, ' ') }} className="button bold">Ask Aristo</Link> :
     <input className="button bold" type="submit" value="Ask Aristo"/>;

   return(
      <div className="debug">
        <form className="spaced">
          <div className="question-box-description">
            Aristo is a system designed to answer grade school level science questions in multiple choice format.
            Aristo may not perform well with questions of other types or about other topics.
            Use the questions above as inspiration for forming your own question!
          </div>

          <textarea id="question-box"
            ref="questionInput"
            maxLength="500"
            className="debug-question-text-area"
            value={this.state.question}
            placeholder="Ask Aristo a question or click on a sample question above!"
            onChange={event => this.setState({ question: event.target.value })}/>
          <div className="text-center">
            {askQuestion}
          </div>
        </form>
      </div>);
  }
}
